import { cssRule } from 'typestyle';

cssRule('.tb-enable-selection', {
    '-webkit-user-select': 'text',
    '-moz-user-select': 'text',
    '-ms-user-select': 'text',
    /* error: '-o-user-select': 'text', */
    userSelect: 'text',
});

